import * as yup from 'yup';

export const manualAddressFormValidation = yup.lazy(() =>
  yup.object().shape(
    {
      index: yup.string().required('Укажите почтовый индекс'),
      regionName: yup.string().required('Выберите регион из справочника'),
      regionFiasId: yup.mixed().when(['regionName'], {
        is: (regionName) => !!regionName,
        then: yup.string().required('Выберите регион из справочника'),
        otherwise: yup.string(),
      }),
      districtName: yup.string(),
      districtKladrCode: yup.mixed().when(['districtName'], {
        is: (districtName) => !!districtName,
        then: yup.string().required('Выберите район из справочника'),
        otherwise: yup.string(),
      }),
      cityName: yup.mixed().when(['settlementName'], {
        is: (settlementName) => !settlementName,
        then: yup.string().required('Выберите город из справочника'),
        otherwise: yup.string(),
      }),
      cityFiasId: yup.mixed().when(['cityName'], {
        is: (cityName) => !!cityName,
        then: yup.string().required('Выберите город из справочника'),
        otherwise: yup.string(),
      }),
      settlementName: yup.mixed().when(['cityName'], {
        is: (cityName) => !cityName,
        then: yup.string().required('Заполните название населенного пункта'),
        otherwise: yup.string(),
      }),
      settlementType: yup.mixed().when(['settlementName'], {
        is: (settlementName) => !!settlementName,
        then: yup.mixed().required('Выберите тип населенного пункта'),
        otherwise: yup.mixed(),
      }),
      streetName: yup.string(),
      streetType: yup.mixed().when(['streetName'], {
        is: (streetName) => !!streetName,
        then: yup.mixed().required('Выберите тип улицы'),
        otherwise: yup.mixed(),
      }),
      houseNumber: yup.mixed(),
      houseType: yup.mixed().when(['houseNumber'], {
        is: (houseNumber) => !!houseNumber,
        then: yup.mixed().required('Выберите тип дома'),
        otherwise: yup.mixed(),
      }),
      building: yup.mixed(),
      buildingType: yup.mixed().when(['building'], {
        is: (buildingType) => !!buildingType,
        then: yup.mixed().required('Выберите тип корпуса/строения'),
        otherwise: yup.mixed(),
      }),
      apartmentNumber: yup.mixed(),
      apartmentType: yup.mixed().when(['apartmentNumber'], {
        is: (apartmentNumber) => !!apartmentNumber,
        then: yup.mixed().required('Выберите тип помещения'),
        otherwise: yup.mixed(),
      }),
    },
    [['cityName', 'settlementName']]
  )
);
